import { render, staticRenderFns } from "./ali_upload.vue?vue&type=template&id=37aaa7b8&scoped=true&"
import script from "./ali_upload.vue?vue&type=script&lang=js&"
export * from "./ali_upload.vue?vue&type=script&lang=js&"
import style0 from "./ali_upload.vue?vue&type=style&index=0&id=37aaa7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aaa7b8",
  null
  
)

export default component.exports